import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import gsap from "gsap";

export default {
  data() {
    return {
      id: this.$options.name,
      collections: [],
      company: this.$store.state.company,
      user: this.$store.state.user,
      activeCollectionId: null,
      collectionBtnStatus: false,
      loading: true,
    };
  },
  created() {
    this.setActiveCollection();

    this.getCollections();

    EventBus.$on(`collection-tree-update`, this.getCollections);

    EventBus.$on(`right-sidebar-show`, (data) => {
      if (data.id === "newCollection") {
        this.collectionBtnStatus = true;
      }
    });

    EventBus.$on(`closeallactions`, () => {
      this.collectionBtnStatus = false;
    });
  },
  methods: {
    handleUpdateName(e) {
      const input = e.target;

      input.setAttribute("size", input.value.length);

      const formData = new FormData();

      formData.append("name", input.value);
      formData.append("collectionid", this.activeCollectionId);

      this.$axios.get(baseUrl + "/collectionedit", formData).then((r) => {
        console.log(r);
      });
    },
    handleBlur(e, oldTitle) {
      const input = e.target;

      input.value = oldTitle;
      input.setAttribute("size", oldTitle.length);
    },
    handleInput(e) {
      const input = e.target;
      input.setAttribute("size", input.value.length);
    },
    getCollections(collections) {
      this.loading = true;

      if (!collections) {
        this.$axios
          .get(baseUrl + "/collectionsall")
          .then((r) => {
            this.collections = r.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.collections = collections;
      }
    },

    collectionDetail(id) {
      this.$router.push(
        `/${this.$store.state.company}/collection/expanded/${id}`
      );
    },
    addCollection() {
      if (this.collectionBtnStatus) {
        //close actions
        EventBus.$emit(`closeallactions`);
      } else {
        EventBus.$emit(`right-sidebar-show`, {
          id: "newCollection",
          data: {},
        });
      }
    },
    setActiveCollection() {
      this.activeCollectionId = this.$route.params.id;
    },
    onEnter(el, done) {
      gsap.from(el, {
        opacity: 0,
        x: -10,
        delay: el.dataset.index * 0.05,
        onComplete: done,
      });
    },
    onLeave(el, done) {
      gsap.to(el, {
        opacity: 0,
        x: -10,
        delay: el.dataset.index * 0.05,
        onComplete: done,
      });
    },
  },
  watch: {
    collections() {},
    $route() {
      this.setActiveCollection();
    },
  },
};
